export type ThemeFontFamilyName = 'body' | 'heading';

export const Fonts: Record<ThemeFontFamilyName, string[]> = {
  body: ['Montserrat', 'Arial', 'sans-serif'],
  heading: ['Fira Sans Extra Condensed', 'Arial', 'sans-serif'],
};
